import React from 'react';

import COLORS from '../../../constants/colors.constants';

const BrandCaretUpIcon = ({
  className = '',
  width = 10,
  height = 6,
  fill = COLORS.brand,
}) => (
  <svg className={className} width={width} height={height} viewBox="0 0 10 6" fill="none">
    <path d="M0.431635 4.63763C0.221647 4.84762 0.370369 5.20667 0.667337 5.20667H9.07971C9.37668 5.20667 9.5254 4.84762 9.31541 4.63763L5.10923 0.431442C4.97905 0.301267 4.768 0.301267 4.63782 0.431442L0.431635 4.63763Z" fill={fill}/>
  </svg>
)

export default BrandCaretUpIcon;
